/**
 * TOOLBAR TOKENS
 * Source: 🔧 Custom — not defined in Figma component tokens
 */

import { type SemanticTokens, SEMANTIC } from '../semantic.js';

export function createToolbarTokens(s: SemanticTokens) {
  return {
  bg: s.surface.ground,                       // --toolbar-bg: var(--surface-ground)
  fg: s.text.secondary,                       // --toolbar-fg: var(--text-secondary)
  border: s.border.default,                   // --toolbar-border: var(--border-default)
  base: {
    borderWidth: '0.0625rem',                // --toolbar-base-border-width (1px)
    paddingX: s.layout.padding.md,           // --toolbar-base-padding-x (3rem/48px)
  },
  start: {
    gap: s.layout.gap.xl,                    // --toolbar-start-gap (2rem/32px)
  },
  button: {
    gap: s.layout.gap.sm,                    // --toolbar-button-gap (0.5rem/8px)
    padding: s.layout.gap.md,                // --toolbar-button-padding (1rem/16px)
    fontFamily: s.typography.fontFamily.base, // --toolbar-button-font-family
    fontSize: s.typography.fontSize.sm,       // --toolbar-button-font-size
    fontWeight: s.typography.fontWeight.bold, // --toolbar-button-font-weight
    lineHeight: s.typography.lineHeight.lg,   // --toolbar-button-line-height
    iconSize: s.iconSizes.lg,                // --toolbar-button-icon-size
    transition: s.transition.fast,           // --toolbar-button-transition
  },
  };
}
export const toolbarTokens = createToolbarTokens(SEMANTIC);